import routeTypes from './route-types'

const SystemModuleView = () => import(/* webpackChunkName: "superadmin-systemmodule-chunk" */ './SystemModuleView.vue')
const SystemModulesDetail = () => import(/* webpackChunkName: "superadmin-systemmodule-chunk" */ './SystemModulesDetail.vue')

export default [
  {
    path: routeTypes.SystemModuleView.path,
    name: routeTypes.SystemModuleView.name,
    component: SystemModuleView,
    meta: {
      title: 'FlexiQuote Module'
    },
    children: [
      {
        path: '',
        name: routeTypes.SystemModulesDetail.name,
        component: SystemModulesDetail,
        meta: {
          title: ''
        }
      }
    ]
  }
]
